import React from "react";
import { Link } from "react-router-dom";
import { ECOSYSTEM_METRICS, ECOSYSTEM_PRODUCTS } from "../data/ecosystemData";
import latticeLogo from "../../../assets/homepage1/lattice-logo.png";

export const HeroSection: React.FC = () => {
  const scrollToSection = (id: string) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section className="homepage1-hero-section">


      {/* Clean Lattice Emblem */}
      <div className="homepage1-hero-emblem">
        <img
          src={latticeLogo}
          alt="indexx.ai emblem"
          onError={(e) => {
            // Fallback if local asset is unavailable
            (e.target as HTMLImageElement).src =
              "https://lh3.googleusercontent.com/aida-public/AB6AXuCbZl46EMOHlmScAlPogh3LXcma_FXIMqs5fGgQxO6ENLb1MYd4wQ_YqBMAGTw8CWPuxA0qdENgozVLYagRBn0ChNVsNSIpvi1jyNKEasKb0vUEQSe9Uy2ja01_tk0hgGZ1BQ7vEHN_uOvm3cirVNbro2J9P4eTTw4Uh75h8pxyd9lS1-UQHcih_HugD9WuQpPgRwp2wSVAsvI9WgDi20yWfDqizbDwUN0sJFR9XGTtqfvtQTGY50iyahpFZWNNPozhxySHm7vf1SQakeE";
          }}
        />
      </div>

      {/* Crisp Understated Headline */}
      <h1 className="homepage1-hero-title">
        The Unified Ecosystem of AI &amp; Crypto
      </h1>

      <p className="homepage1-hero-desc">
        <strong>indexx.ai</strong> connects predictive machine intelligence with
        modular decentralized finance across an interconnected suite of 16
        native platforms.
      </p>

      {/* Refined Minimal CTA Cluster */}
      <div className="homepage1-hero-ctas">
        <button
          type="button"
          className="homepage1-btn-primary"
          onClick={() => scrollToSection("suite")}
        >
          <span>Explore All {ECOSYSTEM_PRODUCTS.length} Products</span>
          <span className="material-symbols-outlined text-base">
            arrow_forward
          </span>
        </button>
        <Link to="/auth/signup-email" className="homepage1-btn-ghost">
          <span className="material-symbols-outlined text-base">
            rocket_launch
          </span>
          <span>Get Started</span>
        </Link>
      </div>

      {/* Clean Linear Metrics Bar */}
      {/* <div className="homepage1-metrics-bar">
        {ECOSYSTEM_METRICS.map((metric, idx) => (
          <div key={idx} className="homepage1-metric-item">
            <div className="homepage1-metric-val">{metric.value}</div>
            <div className="homepage1-metric-lbl">{metric.label}</div>
          </div>
        ))}
      </div> */}
    </section>
  );
};

export default HeroSection;
